/** Menú's draft patch: a patch still travelling when the page closes is not lost (docs/decisions/2026-10-31-menu-saves-in-the-background.md). */
export const MENU_KEEPALIVE_OPERATION = 'patchCatalogDraftEntities' as const;
